export const SEQUENCE_FIELDS = `
    id
    number
    openedAt
    closedAt
`;
